import React from 'react';
import StudentPortfolioApp from './StudentPortfolioApp';

function App() {
  console.log('App component rendering...');
  
  return <StudentPortfolioApp />;
}

export default App;
